import {SelectedCarrierServiceOption} from '@wix/auto_sdk_ecom_current-cart';
import {DeliveryMethod} from '@wix/auto_sdk_ecom_cart-v-2';

export class DeliveryMethodModel {
  public code: string;
  public pickup: boolean;
  /**
   * @deprecated
   */
  public pickupMethod?: string;

  constructor(params: DeliveryMethodModel) {
    this.code = params.code;
    this.pickup = params.pickup;
    this.pickupMethod = params.pickupMethod;
  }

  public static fromCartV1(selectedShippingOption: SelectedCarrierServiceOption) {
    return new DeliveryMethodModel({
      code: selectedShippingOption?.code,
      pickup: !!selectedShippingOption?.logistics?.pickupDetails?.pickupMethod,
      pickupMethod: selectedShippingOption?.logistics?.pickupDetails?.pickupMethod,
    });
  }
  public static fromCartV2(deliveryMethod: DeliveryMethod): DeliveryMethodModel {
    return new DeliveryMethodModel({
      code: deliveryMethod.code,
      pickup: Boolean(deliveryMethod.pickup),
    });
  }
}
